<div
  *ngIf="!indexHeaderInfo()"
  class="fixed inset-0 bg-white opacity-50 flex items-center justify-center z-50"
>
  <p-progressSpinner
     styleClass="w-16 h-16"
    strokeWidth="4"
    animationDuration=".5s"
  ></p-progressSpinner>
</div>
<div class="flex justify-center">
<div *ngIf="indexHeaderInfo() as hi" class="border-b border-gray-300 bg-white w-[80vw]">
  <div
    class="flex flex-col lg:flex-row justify-between items-start lg:items-center
     gap-y-2 max-w-screen-2xl mx-auto px-4 py-6 ">
    <div>
      <div class="flex items-center gap-2 -ml-15">
        <button type="button" (click)="goHome()" class="flex items-center text-gray-700  hover:text-green-700 mt-10">
          <i class="pi pi-angle-left" style="font-size: xxx-large"></i>
        </button>
        <h1 class="text-2xl lg:text-2xl font-bold text-gray-800">{{hi?.marketingName}}</h1>
      </div>
      <div class="text-sm  text-gray-500 -mt-4">
        Last update :<span class="font-bold text-gray-800 px-1">{{hi?.lastUpdateDate}}</span>
      </div>
    </div>
    <div class="flex flex-wrap items-center gap-4 pt-2 lg:pt-0 shrink">
      <div *ngIf="hasLivePrice" class="flex  items-center gap-x-2 border-r-2 border-gray-300 pr-4 last:border-none">
        <span class="text-xs  "><span class="font-bold">live </span> price </span>
        <span class="text-green-700 font-bold text-lg gap-2">{{ livePrice }}</span>
      </div>
      <div class="flex  items-center gap-x-2 border-r-2 border-gray-300 pr-4 last:border-none">
        <span class="text-xs  "><span class="font-bold">Closing </span> price </span>
        <span class="text-green-700 font-bold text-lg gap-2">{{ hi?.closingPrice }}</span>
      </div>
      <div class="flex  items-center gap-x-2 border-r-2 border-gray-300 pr-4 last:border-none">
        <span class="text-xs"><span class="font-bold">1 Day </span> return </span>
        <span [ngClass]="getReturnClass(hi.oneDayReturn)">{{ hi?.oneDayReturn }}%</span>
      </div>
      <div class="flex  items-center gap-x-2 border-r-2 border-gray-300 pr-4 last:border-none">
        <span class="text-xs"><span class="font-bold">1 Month </span> return </span>
        <span [ngClass]="getReturnClass(hi.oneMonthReturn)">{{ hi?.oneMonthReturn }}%</span>
      </div>
      <div class="flex  items-center gap-x-2">
        <span class="text-xs"><span class="font-bold">1 Year </span> return </span>
        <span [ngClass]="getReturnClass(hi.oneYearReturn)">{{ hi?.oneYearReturn }}%</span>
      </div>
    </div>
  </div>
</div>
</div>
